module.exports = __webpack_public_path__ + "img/work_cover_gray.c6448795.svg";